export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/receipt-invoice/:patientID/:visitNO`,
        name: `${prefix}.receipt-invoice.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice.create`,
                PageDescription: "Accounts: Receipt/Invoice",
            },
        },
    },
];